import { getCurrencySymbol } from '@angular/common';

const CURRENCY_SYMBOL_OVERRIDES: Record<string, string> = {
  // U+20C1 SAUDI RIYAL SIGN (Unicode 17.0, Sep 2025). Angular's CURRENCIES_EN has no SAR entry,
  // so getCurrencySymbol('SAR') returns "SAR" verbatim. If users report tofu rendering, either
  // bundle Saudi-Riyal-Font.woff2 with @font-face unicode-range U+20C1, or swap to U+FDFC '﷼'.
  SAR: '⃁',
};

export function getCurrencySymbolWithFallback(
  code: string | null | undefined,
  format: 'narrow' | 'wide' = 'narrow',
  locale?: string
): string {
  if (!code) return '';
  const override = CURRENCY_SYMBOL_OVERRIDES[code];
  if (override) return override;

  return getCurrencySymbol(code, format, locale);
}
